import IconAvatar from "common/components/IconAvatar";
import Skeleton from "common/components/ui/Skeleton";

import LeadListSourceTypeTag from "./LeadListSourceTypeTag";

import type { LeadListSource } from "../types";

const MAX_COMPACT_SOURCES = 4;
//the count isn't known while the sources load, so the placeholder settles on a
//neutral two
const LOADING_SOURCES_COUNT = 2;

interface LeadListSourcesTagProps {
  sources: LeadListSource[];
  isLoading?: boolean;
  isAlwaysCompact?: boolean;
}

export default function LeadListSourcesTag({
  sources,
  isLoading = false,
  isAlwaysCompact = false,
}: LeadListSourcesTagProps) {
  if (isLoading) {
    return (
      <div className="flex flex-row -space-x-1">
        {Array.from({ length: LOADING_SOURCES_COUNT }, (_, index) => (
          <Skeleton
            // biome-ignore lint/suspicious/noArrayIndexKey: placeholders have nothing else to key on
            key={index}
            className="size-6 rounded-lg"
          />
        ))}
      </div>
    );
  }

  if (sources.length === 1) {
    return (
      <LeadListSourceTypeTag
        type={sources[0].type}
        isCompact={isAlwaysCompact}
      />
    );
  }

  const visibleSources = sources.slice(0, MAX_COMPACT_SOURCES);
  const overflowSources = sources.slice(MAX_COMPACT_SOURCES);

  return (
    <div className="flex flex-row -space-x-1">
      {visibleSources.map(({ id, type }) => (
        <LeadListSourceTypeTag key={id} type={type} isCompact />
      ))}

      {!!overflowSources.length && (
        <IconAvatar
          size="xs"
          className="bg-black-100 text-black-700 ring-1 ring-black-200"
        >
          <span className="text-button-xxs">+{overflowSources.length}</span>
        </IconAvatar>
      )}
    </div>
  );
}
